import React from 'react';
import { Link } from 'react-router-dom';
import { VERTICALS } from '../verticals/catalog';
import { oaAppPath } from './paths';

export function OncoAgentPathways(): React.ReactElement {
  return (
    <div>
      <p className="oa-app-kicker">First-mile protocols</p>
      <h1 className="oa-app-title">Pathways for the cancers clinics actually refer</h1>
      <p className="oa-app-sub">
        Oral, uro, and skin were the first three. The desk now covers the common solid tumors,
        heme, gyn, and a general catch-all when the presentation is still messy.
      </p>
      <div className="oa-app-home-grid">
        {VERTICALS.map((v) => (
          <Link key={v.id} className="oa-app-card" to={oaAppPath(`/pathways/${v.id}`)}>
            <h2>{v.title}</h2>
            <p>
              {v.specialty}. {v.blurb}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default OncoAgentPathways;
